export const GET_CUSTOMERS_REQUEST   = "GET_CUSTOMERS_REQUEST";
export const GET_CUSTOMERS_SUCCESS   = "GET_CUSTOMERS_SUCCESS";
export const GET_CUSTOMER_REQUEST    = "GET_CUSTOMER_REQUEST";
export const GET_CUSTOMER_SUCCESS    = "GET_CUSTOMER_SUCCESS";
export const DELETE_CUSTOMER_REQUEST = "DELETE_CUSTOMER_REQUEST";
export const DELETE_CUSTOMER_SUCCESS = "DELETE_CUSTOMER_SUCCESS";
export const GET_REQUEST_ERROR       = "GET_REQUEST_ERROR";
export const GET_REQUEST_SUCCESS     = "GET_REQUEST_SUCCESS";